import { TrailerDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/trailer_events_pb';
import { TrailerStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/trailer_pb';
import {
  BadgeField,
  Col,
  FieldDisplay,
  IDField,
  ThemeColor,
} from '@rematter/ui-web';

import { trailerStatusLabels } from '../enumLabels';

const getStatusColor = (status: TrailerStatus): ThemeColor => {
  switch (status) {
    case TrailerStatus.AVAILABLE:
      return 'success';
    case TrailerStatus.IN_USE:
      return 'teal';
    case TrailerStatus.INACTIVE:
      return 'neutral';
    default:
      return 'neutral';
  }
};

type TrailerDeletedDetailProps = {
  event: TrailerDeletedEvent;
};

export const TrailerDeletedDetail = ({ event }: TrailerDeletedDetailProps) => {
  const trailer = event.trailer;

  if (!trailer) {
    return (
      <Col className="@TrailerDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@TrailerDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Trailer
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={trailer.id?.value} />
          <FieldDisplay label="License Plate" value={trailer.licensePlate} />
          <BadgeField
            label="Status"
            value={trailerStatusLabels[trailer.status]}
            color={getStatusColor(trailer.status)}
          />
          <FieldDisplay label="VIN" value={trailer.vin} />
          <FieldDisplay
            label="Capacity"
            value={trailer.capacity ? String(trailer.capacity) : ''}
          />
          <FieldDisplay label="Country" value={trailer.country} />
          <FieldDisplay label="State" value={trailer.state} />
        </div>
      </Col>
    </Col>
  );
};
